<template>
  <PromotionGiftConditionBanner
    v-if="promotion"
    v-bind="{ label }"
    :style="getPromotionStyle(promotion.customData)"
    :schedule-to="promotion.schedule.to"
  />
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

const props = defineProps<{ product: Product }>()

const {
  buyXGetYPromotion: promotion,
  quantityLeftForGiftConditions: quantityLeft,
  minOrderValueLeft,
} = await useProductPromotions(props.product)

const { label } = usePromotionConditionBanner(minOrderValueLeft, quantityLeft)
</script>
